import { catchError } from 'rxjs/operators';
import { TokenService } from './../services/token.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private toastService: NbToastrService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const tokenB64 = this.tokenService.getTokenB64();
    if (tokenB64 && tokenB64 !== "") {
      request = request.clone({
        setHeaders: {
          'Authorization': `Basic ${tokenB64}`
        }
      });
    }
    return next.handle(request).pipe(catchError(err => this.handleAuthError(err, request)));
  }

  /**
   * El backend (tokenapi) devuelve 401/403 cuando el par usuario/token no es válido,
   * lo cual pasa sobre todo cuando el token venció (TTL de 30 días, ver
   * TOKEN_TIMEOUT_DAYS en settings.py). No hay endpoint de refresh, así que la
   * única salida es volver a loguearse. Antes este caso se ignoraba en silencio
   * y el despachador nunca se enteraba de que las alertas dejaron de salir.
   * Se excluye el propio POST de login para no pisar el mensaje de "usuario o
   * clave incorrecta", y no se toca el status 0 (server/red caída) para no
   * reintroducir el logout espurio que se había comentado por eso mismo.
   */
  private handleAuthError(err: HttpErrorResponse, request: HttpRequest<unknown>): Observable<never> {
    const isLoginRequest = request.url.includes('/token/new.json');
    const isSessionInvalid = (err.status === 401 || err.status === 403) && !isLoginRequest;

    if (isSessionInvalid && !this.router.url.startsWith('/login')) {
      this.tokenService.removeToken();
      this.toastService.danger(
        "Tu sesión expiró y las alertas pueden no haberse enviado. Volvé a iniciar sesión.",
        "Sesión expirada",
        { destroyByClick: true, duration: 0 }
      );
      this.router.navigateByUrl('/login');
    }

    return throwError(err);
  }
}
